export interface ApiAgentUser {
    PartnerId: number;
    Type: number;
    PartnerName: string;
    UniqueName: string;
    ContactPersonFirstName: string;
    ContactPersonLastName: string;
    PhoneNumber: string;
    CompanyUniqueId: string | null;
    Email: string;
    Address1: string | null;
    Address2: string | null;
    City: string | null;
    StateId: number | null;
    CountryId: number | null;
    ZipCode: string | null;
    Notes: string | null;
    IsActive: boolean;
    Commission: string | null;
    AllowInvoice: boolean;
    Website: string;
    Country: string | null;
    State: string | null;
    IsParentCompany: boolean | null;
    IsCruiseLine: boolean | null;
    ShipCompanyId: string | null;
    IsTaxable: boolean | null;
}

/**
 * Example:
    {
        PartnerId: 35,
        Type: 0,
        PartnerName: 'Alaska \u0026 Yukon Tours',
        UniqueName: 'Alaska \u0026 Yukon Tours',
        ContactPersonFirstName: 'Nate',
        ContactPersonLastName: 'Vallier',
        PhoneNumber: '(907) 531-9140',
        CompanyUniqueId: null,
        Email: 'nate@alaskayukontours.com',
        Address1: null,
        Address2: null,
        City: null,
        StateId: null,
        CountryId: null,
        ZipCode: null,
        Notes: null,
        IsActive: true,
        Commission: null,
        AllowInvoice: true,
        Website: 'www.alaskaexcursions.net',
        Country: null,
        State: null,
        IsParentCompany: null,
        IsCruiseLine: false,
        ShipCompanyId: null,
        IsTaxable: null,
    },
 */
